import { enableFade } from 'core/handlers/FadeHandler'
import * as isWebview from 'is-ua-webview'
import { gameStorage } from 'services/ElementsStorageService'
import { signal } from 'services/SignalsService'
import { backEndVersion } from 'settings/custom/general'
import { spinSettings } from 'settings/custom/reels'

import { POST_MESSAGE_EVENTS } from '../../../consts/consts'
import { sendPostMessage } from '../../../services/PostMessageService'
import { social } from '../../../settings/custom/build'

export default class MenuEntity extends PIXI.Container {
  constructor() {
    super()
    this._isDepositHandled = false
    const fade = enableFade(this)

    signal.on('DISPLACEMENT:BUTTON', ({ orientation }) => {
      let socialMode = false
      let socialGame = false
      if(spinSettings.hasOwnProperty('socialMode')){
        socialMode = true
      }
      if(social && spinSettings.hasOwnProperty('socialGame')) {
        socialGame = true
      }

      if (!this._isDepositHandled) {
        this.defaultPositionsPort = new Map()
        this.children.forEach((child) => {
          this.defaultPositionsPort.set(child, {
            x: child.data.orientation.port.x,
          } )
        })
      }

      if (game.models.GameModel.deposit === '') {
        this.removeMenuDeposit(orientation)
      }
      this._isDepositHandled = true

      if(game.models.GameModel.action === 'demo' || game.models.GameModel.mode === 'demo' ||  socialMode || socialGame) {
        this.removeChild(gameStorage.get('menuhistory'))
        this.children.forEach((item) => {
          if (item.name !== 'ui-menu'){
            if (orientation === 'land'){
              item.y = item.y + 40
            }
            else {
              item.x = item.x + 40
            }
          }
        })
      }
    })

    signal.on('RADIO:ui', (value) => {
      fade(value === 'menu')
      const isPaytable = value === 'menu' ? 'paytable' : ''
      signal.dispatch(`UI:RG:ENTITY${isPaytable ? ':HIDE' : ':SHOW'}`, true)
      signal.dispatch('RADIO:menu', isPaytable )
      if (value === 'menu'){
        signal.dispatch(`RADIO:menu:${isPaytable }`)
      }
      if (value === ''){
        signal.dispatch('RADIO:menu:all')
      }
    })
    // todo radio groups close on spin
    signal.on('STATE:OUT:BET', () => {
      signal.dispatch('RADIO:ui', false)
    })

    signal.on('BUTTON:menuhome', () => {
      if(game.models.GameModel.home === '') {
        return
      }

      const postMessageEvents = game.models.GameModel.integrationPostMessageEvents
      const event = postMessageEvents[POST_MESSAGE_EVENTS.GAME_EXIT]

      if (event) {
        sendPostMessage(event.eventName)
      }
      else {
        window.top.location.href  = game.models.GameModel.home
      }
    })

    signal.on('BUTTON:menuhistory', () => {
      if(backEndVersion === 2){
        if(isWebview(window.navigator.userAgent)){
          window.top.location.href  = game.models.GameModel.history
        }
        else {
          window.open(game.models.GameModel.history, '_blank').focus()
        }

      }
    })

    signal.on('BUTTON:menucashier', () => {
      const postMessageEvents = game.models.GameModel.integrationPostMessageEvents
      const event = postMessageEvents[POST_MESSAGE_EVENTS.DEPOSIT_OPEN]

      if (event) {
        sendPostMessage(event.eventName)
      }
      else {
        if(game.models.GameModel.deposit === '') {
          return
        }

        window.top.location.href  = game.models.GameModel.deposit
      }
    })
  }

  removeMenuDeposit(orientation) {
    const depositElement = gameStorage.get('menucashier')
    const homeBtn = gameStorage.get('menuhome')

    this.removeChild(depositElement)

    if (orientation === 'land'){
      homeBtn.y = depositElement.y
      homeBtn.data.orientation.land.y = depositElement.data.orientation.land.y
    }
    else {
      const shiftX = depositElement.x - homeBtn.x
      this.children.forEach((child) => {
        if (child.name === 'ui-menu') {
          return
        }

        if (child.name === 'menuhome') {
          return
        }

        child.data.orientation.port.x = this.defaultPositionsPort.get(child).x - shiftX
      })
    }
  }
}
